import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  globalFeatures: any;
};

type Action = {
  setGlobalFeatures: (globalFeatures: State['globalFeatures']) => void;
};

const initialState: State = {
  globalFeatures: [],
};

const globalFeaturesStore = create(
  devtools((set: any, get: any) => ({
    ...initialState,
    setGlobalFeatures: (globalFeatures) =>
      set(() => ({
        globalFeatures,
      })),
  })),
);

// Hook to get a specific feature flag
export const useGlobalFeature = (featureName: string) => {
  const globalFeatures = globalFeaturesStore((state) => state.globalFeatures);

  // Find the feature by name
  const isEnabled = globalFeatures[featureName];

  return isEnabled || false; // Return boolean value or default to false
};

// Hook to get all features
export const useGlobalFeatures = () => {
  return globalFeaturesStore((state) => state.globalFeatures);
};

export default globalFeaturesStore;
